// src/app/components/map/map.component.ts
import { Component, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';
import { MapService, IpPoint } from '../../../services/map.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements AfterViewInit {
  private map: L.Map;
  private markers: L.CircleMarker[] = [];

  // valores por defecto (puedes cambiarlos aquí o vinculándolos a inputs/UI)
  element = 'pixel-exportadores-argentina';
  start:   string;
  end:     string;

  constructor(private mapService: MapService) {}

  ngAfterViewInit(): void {
    this.initMap();
    this.loadAndDraw();
  }

  private initMap() {
    this.map = L.map('map').setView([20, 0], 2);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap'
    }).addTo(this.map);
  }

  /** Llama al servicio con los filtros actuales */
  loadAndDraw() {
    // limpia marcadores anteriores
    this.markers.forEach(m => this.map.removeLayer(m));
    this.markers = [];

    this.mapService
      .getIpPoints(this.element, this.start, this.end)
      .subscribe(points => {
        points.forEach(p => {
          const m = L.circleMarker([p.latitude, p.longitude], {
            radius: Math.log(p.count + 1) * 4,
            fillOpacity: 0.6
          })
          .bindPopup(`<strong>${p.ip}</strong><br/>Vistas: ${p.count}`)
          .addTo(this.map);
          this.markers.push(m);
        });
      });
  }
}
